"use strict";
var WebSocketSubject_1 = require("./WebSocketSubject");
exports.webSocket = WebSocketSubject_1.WebSocketSubject.create;
//# sourceMappingURL=webSocket.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/observable/dom/webSocket.js
 ** module id = 256
 ** module chunks = 1
 **/